<div *ngIf="auth.user$ | async as user; else NoUser">
<button kendoButton look="outline"  (click)="onActivate($event)" class="k-button large"  [primary]="true" >
  Update Fastlink Blueprint
</button>
  Will show under {{ user.name }}
</div>
<ng-template #NoUser>
  <button kendoButton look="outline"  (click)="onActivate($event)" class="k-button large"  [disabled]="false" [primary]="true" >
    Update Fastlink Blueprint
  </button>
</ng-template>

